import { motion } from "framer-motion";
import { Eye } from "lucide-react";

export const TruthSection = ({ onBegin }) => {
    return (
        <section id="truth" data-testid="truth-section" className="relative px-5 py-28 sm:px-8 lg:py-36">
            <div className="nebula-blob left-[10%] top-[20%] h-96 w-96 bg-[#5a189a]/20" />
            <div className="nebula-blob bottom-[0%] right-[5%] h-[26rem] w-[26rem] bg-[#2e0b53]/40" />
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9 }}
                className="relative mx-auto max-w-3xl text-center"
            >
                <p className="eyebrow mb-4">Chapter V · The Truth</p>
                <h2 className="text-glow-lilac font-display text-2xl font-bold leading-snug tracking-wide text-[#f8f7ff] sm:text-3xl lg:text-4xl">
                    DO YOU SUSPECT YOU'RE BEING LIED TO?
                </h2>
                <div className="mt-7 space-y-5 font-cormorant text-lg italic leading-relaxed text-[#e0aaff]/85 sm:text-xl">
                    <p>
                        Stop questioning your instincts. Tell Mara what happened and receive an immediate, direct reading
                        into the truth being hidden from you.
                    </p>
                    <p className="text-[#f8f7ff]">No vague answers. No waiting. Mara will tell you what she sees.</p>
                </div>
                <button type="button" onClick={onBegin} data-testid="ask-mara-now-button" className="btn-glow mt-10">
                    <span className="mirror-sheen absolute inset-0 animate-shimmer-line" />
                    <span className="relative flex items-center gap-3">
                        <Eye className="h-4 w-4" />
                        ASK MARA NOW
                    </span>
                </button>
            </motion.div>
        </section>
    );
};
